<script>
  import Title from "./comp/title.svelte";
  import MapCanvas from "./comp/map.svelte";
  import Modal from "./comp/modal.svelte";
  import { push, pop } from "svelte-spa-router";

  let shown = false;

  push("/WW");
  shown = true;

  function openModal(e) {
    shown = true;
    let nameUrl = e.detail.name;
    if (nameUrl == "Self Love") {
      nameUrl = "Self-Love";
    }
    push(`/${nameUrl}`);
  }

  function closeModal(e) {
    shown = false;
    push(`/`);
  }

  window.addEventListener("popstate", (event) => {
    if (event.path[0].location.hash == "#/" || "") {
      shown = false;
    } else {
      shown = true;
    }
  });
</script>

<main>
  <Modal {shown} on:close={closeModal} />
  <div>
    <Title />
    <MapCanvas on:pressed={openModal} />
  </div>
</main>

<style>
  main {
    width: 1200px;
    height: 900px;
    margin: auto;
    position: relative;
  }
  div {
    width: 100%;
    height: 100%;
    display: flex;
  }

  @media only screen and (max-width: 1200px) {
    main {
      width: 737px;
    }
  }
</style>
